const WATERMARK_TEXT_HELP = '仅支持中文、英文、数字和常用符号；不支持 Emoji、其他文字和特殊字符。最多 16 个字符，建议不超过 8 个。';

const ERROR_MESSAGES = {
  REQUIRED: '请输入水印文字。',
  PUNCTUATION_ONLY: '水印不能只包含标点符号。',
  TOO_MANY_CHARACTERS: '水印最多支持 16 个字符。',
  TOO_MANY_BYTES: '水印内容超过 OSS 允许的 64 字节。',
  EMOJI: '水印暂不支持 Emoji 或表情符号。',
  INVISIBLE_CHARACTER: '水印包含不可见字符或换行。',
  UNSUPPORTED_CHARACTER: '水印包含暂不支持的文字或特殊符号。',
};

const EXTENDED_PICTOGRAPHIC_PATTERN = /\p{Extended_Pictographic}/u;
const REGIONAL_INDICATOR_PATTERN = /\p{Regional_Indicator}/u;
const EMOJI_SEQUENCE_MARK_PATTERN = /[\u200D\uFE0F\u20E3]/u;
const EMOJI_MODIFIER_PATTERN = /[\u{1F3FB}-\u{1F3FF}]/u;
const ALLOWED_CHARACTER_PATTERN = /^[A-Za-z0-9\u4E00-\u9FFF &@#%+.,:;!?'"()[\]\-_/\\，。！？：；、“”‘’（）【】《》·©®™]+$/u;
const MEANINGFUL_CHARACTER_PATTERN = /[A-Za-z0-9\u4E00-\u9FFF]/u;

function containsInvisibleCharacter(text) {
  return Array.from(text).some(character => {
    const code = character.codePointAt(0);
    return code <= 0x1F
      || (code >= 0x7F && code <= 0x9F)
      || code === 0xAD
      || code === 0x61C
      || (code >= 0x200B && code <= 0x200F)
      || (code >= 0x202A && code <= 0x202E)
      || (code >= 0x2060 && code <= 0x206F)
      || code === 0xFEFF;
  });
}

function normalizeWatermarkText(value) {
  return String(value ?? '')
    .normalize('NFC')
    .replace(/^ +| +$/g, '')
    .replace(/ {2,}/g, ' ');
}

function invalid(code, text) {
  return { valid: false, code, message: ERROR_MESSAGES[code], text };
}

async function validateWatermarkText(value) {
  const text = normalizeWatermarkText(value);

  if (!text) return invalid('REQUIRED', text);
  // ©, ® and ™ are explicitly supported by OSS even though some Unicode
  // datasets classify them as pictographic characters.
  const emojiCandidate = text.replace(/[©®™]/g, '');
  const hasPictograph = EXTENDED_PICTOGRAPHIC_PATTERN.test(emojiCandidate);
  const hasEmojiSequenceMark = EMOJI_SEQUENCE_MARK_PATTERN.test(emojiCandidate);
  if (
    hasPictograph
    || REGIONAL_INDICATOR_PATTERN.test(emojiCandidate)
    || EMOJI_MODIFIER_PATTERN.test(emojiCandidate)
    || /[\uFE0F\u20E3]/u.test(emojiCandidate)
    || (hasEmojiSequenceMark && hasPictograph)
  ) return invalid('EMOJI', text);
  if (containsInvisibleCharacter(text)) return invalid('INVISIBLE_CHARACTER', text);

  const byteLength = new TextEncoder().encode(text).byteLength;
  if (byteLength > 64) return invalid('TOO_MANY_BYTES', text);
  if (Array.from(text).length > 16) return invalid('TOO_MANY_CHARACTERS', text);
  if (!ALLOWED_CHARACTER_PATTERN.test(text)) return invalid('UNSUPPORTED_CHARACTER', text);
  if (!MEANINGFUL_CHARACTER_PATTERN.test(text)) return invalid('PUNCTUATION_ONLY', text);

  return {
    valid: true,
    code: null,
    message: '',
    text,
    characterLength: Array.from(text).length,
    byteLength,
  };
}

async function getWatermarkTextError(value) {
  const result = await validateWatermarkText(value);
  return result.valid ? '' : result.message;
}

export {
  ERROR_MESSAGES,
  WATERMARK_TEXT_HELP,
  getWatermarkTextError,
  normalizeWatermarkText,
  validateWatermarkText,
};
